import { render, staticRenderFns } from "./recruitment-center.vue?vue&type=template&id=6ad85773&scoped=true"
import script from "./recruitment-center.vue?vue&type=script&lang=js"
export * from "./recruitment-center.vue?vue&type=script&lang=js"
import style0 from "./recruitment-center.vue?vue&type=style&index=0&id=6ad85773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad85773",
  null
  
)

export default component.exports